// The default microblog node: a follow on it is a person (mentionable), any other
// node is a community/topic feed.
export const MICROBLOG_NODE = 'urn:xmpp:microblog:0';
